import React, { useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_BASE
    ? `${process.env.REACT_APP_API_BASE}/phpmailer/oznam.php`
    : '/phpmailer/oznam.php';

function Modul({ onClose, location }) {
    const [announcement, setAnnouncement] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const sessionKey = `petromin_oznam_seen_${location}`;
        if (sessionStorage.getItem(sessionKey)) {
            onClose();
            return;
        }

        const url = location ? `${API_BASE}?location=${location}` : API_BASE;

        fetch(url)
            .then((r) => r.json())
            .then((data) => {
                if (data.status === 'ok') {
                    setAnnouncement(data);
                    sessionStorage.setItem(sessionKey, '1');
                } else {
                    onClose();
                }
            })
            .catch(() => onClose())
            .finally(() => setLoading(false));
    }, [onClose, location]);

    useEffect(() => {
        if (!announcement) return;
        document.body.style.overflow = 'hidden';
        const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', handleKey);
        return () => {
            document.body.style.overflow = '';
            document.removeEventListener('keydown', handleKey);
        };
    }, [announcement, onClose]);

    if (loading || !announcement) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4 backdrop-blur-sm bg-black/50"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-2xl p-8 max-w-lg w-full shadow-2xl"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-start justify-between mb-4">
                    <span className="bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">
                        Oznam
                    </span>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-700 transition-colors duration-200 ml-4"
                        aria-label="Zatvoriť"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <h2 className="text-2xl font-bold text-gray-800 mb-1">{announcement.title}</h2>
                <p className="text-gray-400 text-sm mb-6">{announcement.date}</p>
                <div className="border-t border-gray-100 mb-6" />
                <p className="text-gray-600 leading-relaxed">{announcement.message}</p>

                <button
                    onClick={onClose}
                    className="mt-8 w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 rounded-xl transition-colors duration-200"
                >
                    Zavrieť
                </button>
            </div>
        </div>
    );
}

export default Modul;
